export default {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: false
    },
    table: {
        clickModify: true,
        selectBtn: true,
        leftWidth: 160,
        height: '400px',
        leftOperation: false,
        reserveSelection: true,
        columns: [
            {
                label: '运输单号',
                prop: 'taskNo',
                sort: true,
                width: 170
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                sort: true,
                width: 200
            },
            {
                label: '服务平台',
                prop: 'siteName',
                sort: true,
                width: 140
            },
            {
                label: '收货人电话后四位',
                prop: 'receiverMobileSuffix',
                sort: true,
                width: 160
            },
            {
                label: '目的地址',
                prop: 'receiverDetailAddr',
                sort: true,
                width: 220
            },
            {
                label: '装货仓库',
                prop: 'whName',
                sort: true,
                width: 140
            },
            {
                label: '库区',
                prop: 'zoneName',
                sort: true,
                width: 140
            },
            {
                label: '网点名称',
                prop: 'networkName',
                sort: true,
                width: 140
            },
            {
                label: '客户',
                prop: 'customerName',
                sort: true,
                width: 250
            },
            {
                label: '时效考核时间',
                prop: 'examineTime',
                width: 160,
                sort: true
            },
            {
                label: '方量(m³)',
                prop: 'totalVolume',
                sort: true,
                width: 120
            },
            {
                label: '重量(Kg)',
                prop: 'totalGrossWeight',
                sort: true,
                width: 120
            },
            {
                label: '数量',
                prop: 'totalQty',
                sort: true,
                width: 100
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30]
    },
    // 高级搜索配置项
    searchTotalTitle: []
};
